"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnErrorMessage = void 0;
var returnErrorMessage = function (error, wrongStatusErrorMessage, userNotFoundErrorMessage, expectedError) {
    var errorMessage;
    if (error === expectedError) {
        errorMessage = wrongStatusErrorMessage;
    }
    else {
        errorMessage = userNotFoundErrorMessage;
    }
    return errorMessage;
};
exports.returnErrorMessage = returnErrorMessage;
